<template>
  <div class="timeout">
    <img
      src="./img/500.png"
      alt=""
    >
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.timeout {
  width: 100%;
  height: 100%;
  font-size: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>